export default __webpack_public_path__ + "static/media/potion3.9d506426.png";